import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocationSegments } from "../../../../../../hooks/use-location-segments";
const TABS = [
    {
        identifier: "register",
        label: "Sign Up",
        path: "/auth/register",
        selected: true,
    },
    {
        identifier: "login",
        label: "Sign In",
        path: "/auth/login",
        selected: false,
    },
];
export function useTabsState() {
    const navigate = useNavigate();
    const { segments } = useLocationSegments();
    const [currentTab, setCurrentTab] = useState();
    const lastSegment = useMemo(() => (segments ? segments?.[segments?.length - 1] : "register"), [segments]);
    const tabs = useMemo(() => TABS.map(({ identifier, ...rest }) => ({ ...rest, identifier, selected: identifier === lastSegment })), [currentTab, lastSegment, segments]);
    const handleTabClicked = useCallback((tabId) => () => {
        if (tabId === currentTab) {
            return;
        }
        setCurrentTab(tabId);
        const tab = tabs?.find(({ identifier }) => identifier === tabId);
        if (!!tab) {
            navigate(tab?.path);
        }
    }, [currentTab]);
    return useMemo(() => ({ handleTabClicked, tabs }), [handleTabClicked, tabs]);
}
